import type { TonyteTheme } from './types';

/**
 * Existing StyleSheet rules are the canonical Midnight implementation.
 * Appearance-aware components use this helper for Daylight overrides so
 * introducing the preview cannot subtly change the shipped dark UI.
 */
export const daylightStyle = <T extends object>(theme: TonyteTheme, style: T): T => (
  theme.name === 'daylight' ? style : ({} as T)
);
